import React, { FC } from "react";
import { Document } from "../../PreAuth/PreAuthIhx/PreAuthIhx";
import BasicDetails from "./IHXTabs/BasicDetails";
import { Form, Spin } from "antd";
import BillingDetails from "./IHXTabs/BillingDetails";
import { Button } from "antd";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import DischargeDocumentUpload from "./IHXTabs/DischargeDocumentUpload";
import ResponseDischargeDocumentUpload from "./IHXTabs/ResponseDischargeDocumentUpload";
import Loader from "../../../../utils/Spinners";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { ROUTES } from "../../../../utils/constants";
import { useNavigate } from "react-router-dom";

type DischargeIhxProps = {
  documentTypes: Document[];
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks: string | null;
  }[];
  handleFileChange: any;
  handleOpen: any;
  form: any;
  handleSubmit: any;
  handleIntimate: any;
  handleSubmitOnPortal: any;
  handleApprove: any;
  isApproved: boolean;
  isApprovedInitiated: boolean;
  caseDischargeId: any;
  preAuth: any;
  isSubmitting: boolean;
  isIntimating: boolean;
  isSaving: boolean;
  currentActiveStage: any;
  handleSaveConfirmationModal: any;
  documentRequestResponseDocuments: any;
  handleSaveData: any;
  activeKey: any;
  portalSubmission: boolean;
  loading: boolean;
  caseDischargeData: any;
  uploadFileList: any;
  isSubmittingEmail: any;
  handleInitiateEmail: any;
};

const DischargeIhx: FC<DischargeIhxProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  form,
  handleSubmit,
  handleIntimate,
  handleSubmitOnPortal,
  handleApprove,
  isApproved,
  isApprovedInitiated,
  caseDischargeId,
  preAuth,
  isSubmitting,
  isIntimating,
  isSaving,
  currentActiveStage,
  handleSaveConfirmationModal,
  documentRequestResponseDocuments,
  handleSaveData,
  activeKey,
  portalSubmission,
  loading,
  caseDischargeData,
  uploadFileList,
  isSubmittingEmail,
  handleInitiateEmail
}) => {
  const { hasFunctionality } = useUserFunctionalities();
  const { auth, patients } = useSelector((state: RootState) => state);
  const navigate = useNavigate();
  return (
    <div style={{ overflow: "auto" }}>
      <BasicDetails
        form={form}
        isApproved={isApproved}
        portalSubmission={portalSubmission}
      />

      <BillingDetails
        form={form}
        isApproved={isApproved}
        portalSubmission={portalSubmission}
      />

      {loading ? (
        <div
          style={{
            margin: "auto",
            width: "100%,",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        documentRequestResponseDocuments?.["requestedDocuments"]?.length >
          0 && (
          <DischargeDocumentUpload
            documentTypes={documentTypes}
            documentUrls={documentUrls}
            handleFileChange={handleFileChange}
            handleOpen={handleOpen}
            documentRequestResponseDocuments={documentRequestResponseDocuments}
            portalSubmission={portalSubmission}
            isApproved={isApproved}
            uploadFileList={uploadFileList}
            isIntimated={caseDischargeData?.intimated}
          />
        )
      )}

      {documentRequestResponseDocuments?.["responseDocuments"]?.length > 0 && (
        <ResponseDischargeDocumentUpload
          documentTypes={documentTypes}
          documentUrls={documentUrls}
          handleFileChange={handleFileChange}
          handleOpen={handleOpen}
          portalSubmission={portalSubmission}
          documentRequestResponseDocuments={documentRequestResponseDocuments}
          handleSaveData={handleSaveData}
          currentStage={preAuth?.stepperData?.currentVisitStage}
          activeKey={activeKey}
          uploadFileList={uploadFileList}
        />
      )}

      <div className="buttons" style={{ margin: "16px 0" }}>
        {
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.8rem",
            }}
          >
            {caseDischargeData?.submitted ||
            caseDischargeData?.initiated
            // || caseDischargeData?.approved 
            ? (
              <></>
            ) : !caseDischargeId ? (
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                  }}
                  // onClick={handleSubmit}
                  onClick={() => handleSaveConfirmationModal("save")}
                  loading={isSaving}
                >
                  SAVE
                </Button>
              </div>
            ) : (
              !(
                auth?.role?.role == "FO_STAFF" && caseDischargeData?.intimated
              ) && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmit}
                    onClick={() => handleSaveConfirmationModal("update")}
                    loading={isSaving}
                  >
                    Update
                  </Button>
                </div>
              )
            )}
            {hasFunctionality("dischargeIntimation") ? (
              caseDischargeData?.intimated ||
              caseDischargeData?.submitted ||
              caseDischargeData?.initiated ||
              caseDischargeData?.approved ? (
                <></>
              ) : (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleIntimate}
                    onClick={() => handleSaveConfirmationModal("intimate")}
                    loading={isIntimating}
                  >
                    Send To QC
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}

            {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "OP" &&
              hasFunctionality("opdBillList") && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      // opacity: !isApproved ? 1 : 0.5,
                      // pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
                        navigate({
                          pathname: `${ROUTES.PATIENT_BILLING_LIST}/${patients?.fetchBasicDetails?.casesResponse?.id}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
                        });
                      }
                    }}
                  >
                    Bill Audit
                  </Button>
                </div>
              )}
            {(patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "IP" ||
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                "EMERGENCY") &&
              hasFunctionality("ipdBillList") && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      // opacity: !isApproved ? 1 : 0.5,
                      // pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
                        navigate({
                          pathname: `${ROUTES.PATIENT_BILLING_LIST}/${patients?.fetchBasicDetails?.casesResponse?.id}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
                        });
                      }
                    }}
                  >
                    Bill Audit
                  </Button>
                </div>
              )}

            {hasFunctionality("dischargeApprover") &&
              !caseDischargeData?.initiated &&
              !caseDischargeData?.approved &&
              !caseDischargeData?.submitted && (
                <div style={{ width: "16%" }}>
                  <Button
                    loading={isApprovedInitiated}
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      opacity: !isApproved ? 1 : 0.5,
                      pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    // onClick={handleApprove}
                    onClick={() => handleSaveConfirmationModal("approve")}
                    disabled={isApproved}
                  >
                    QC Approve
                  </Button>
                </div>
              )}

            {hasFunctionality("dischargeSubmission") ? (
              caseDischargeData?.submitted || caseDischargeData?.initiated ? (
                <></>
              ) : (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmitOnPortal}
                    onClick={() => handleSaveConfirmationModal("submit")}
                    loading={isSubmitting}
                  >
                    {patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal ? "Initiate" : "Submit Manually"}
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}

            {hasFunctionality("dischargeSubmission") ? (
              caseDischargeData?.submitted || caseDischargeData?.initiated ? (
                <></>
              ) : (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmitOnPortal}
                    // onClick={() => handleSaveConfirmationModal("submitEmail")}
                    onClick={handleInitiateEmail}
                    loading={isSubmittingEmail}
                  >
                    {"Initiate By Email"}
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}
          </div>
        }
      </div>
    </div>
  );
};

export default React.memo(DischargeIhx);
